import { SERVERLESS_PREFIX } from '../../utils';
export const getInitialAppInstallationDataUrl = _ref => {
  let {
    appId,
    tenantId,
    languageCode,
    version,
    shareUrlId
  } = _ref;
  const urlParams = new URLSearchParams({
    appId,
    ...(version ? {
      version: version === 'dev' ? 'latest' : version
    } : {}),
    ...(shareUrlId ? {
      shareUrlId
    } : {}),
    tenantId,
    languageCode
  }).toString();
  return `${SERVERLESS_PREFIX}/getAppInstallationData?${urlParams}`;
};
//# sourceMappingURL=getInitialAppInstallationDataUrl.js.map